/**
 * Onboarding API functions — pre-authentication flows
 * @module lib/api/onboarding
 */

import { apiClient } from "@/lib/api/client";
import type { ApiEnvelope } from "@/types/api";

export interface EnablerRequestPayload {
  name_ar: string;
  name_en: string;
  entity_type: string;
  email: string;
  responsible_name: string;
  whatsapp: string;
  website?: string;
  message: string;
  logo?: File;
}

export interface EnablerRequestData {
  id: string;
  name_ar: string;
  name_en: string;
  entity_type: string;
  email: string;
  responsible_name: string;
  whatsapp: string;
  website: string | null;
  message: string;
  logo_path: string | null;
  status: "pending" | "approved" | "declined";
  created_at: string;
}

/**
 * Submit an initiative entity account request.
 * Public endpoint — no authentication required.
 * Sends as multipart/form-data when a logo file is included.
 */
export function submitEnablerRequest(
  payload: EnablerRequestPayload
): Promise<ApiEnvelope<EnablerRequestData>> {
  const formData = new FormData();
  formData.append("name_ar", payload.name_ar);
  formData.append("name_en", payload.name_en);
  formData.append("entity_type", payload.entity_type);
  formData.append("email", payload.email);
  formData.append("responsible_name", payload.responsible_name);
  formData.append("whatsapp", payload.whatsapp);
  if (payload.website) formData.append("website", payload.website);
  formData.append("message", payload.message);
  if (payload.logo) formData.append("logo", payload.logo);

  return apiClient.post<EnablerRequestData>("/api_partner/enablers/request", formData);
}
